
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/turnaje",
      function () {
        return require("private-next-pages/turnaje/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/turnaje"])
      });
    }
  